module.exports = __webpack_public_path__ + "img/player-mobile.a7d84468.png";